import { DEFAULT_LOCALE, type SupportedLocale } from "./config";

export function intlLocaleTag(locale: SupportedLocale = DEFAULT_LOCALE): string {
    return locale;
}

export function formatLocaleShortDateTime(
    value: string | null | undefined,
    locale: SupportedLocale = DEFAULT_LOCALE
): string {
    if (!value) {
        if (locale === "de-DE") return "Datum nicht festgelegt";
        if (locale === "da-DK") return "Dato ikke angivet";
        if (locale === "fr-FR") return "Date non définie";
        if (locale === "it-IT") return "Data non impostata";
        if (locale === "es-ES") return "Fecha no establecida";
        return "Date not set";
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        if (locale === "de-DE") return "Datum nicht festgelegt";
        if (locale === "da-DK") return "Dato ikke angivet";
        if (locale === "fr-FR") return "Date non définie";
        if (locale === "it-IT") return "Data non impostata";
        if (locale === "es-ES") return "Fecha no establecida";
        return "Date not set";
    }

    return new Intl.DateTimeFormat(intlLocaleTag(locale), {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: locale === "en-US",
    }).format(date);
}

export function formatLocaleChartDate(
    value: string | null | undefined,
    locale: SupportedLocale = DEFAULT_LOCALE
): string {
    if (!value) {
        return "";
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return new Intl.DateTimeFormat(intlLocaleTag(locale), {
        day: "numeric",
        month: "short",
        year: "numeric",
    }).format(date);
}
